/* eslint-disable func-style */

/**
 * Date utils
 */

export const MONTHS_NAME = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * Creates a Date instance from value.
 * For a string value that contains only digits, it will assume that it's
 * the number of ms returned by getTime() (Unix epoch).
 */
export function toDate(value) {
  if (value instanceof Date) {
    return new Date(value.getTime());
  }
  if (typeof value === 'string' && /^\d+$/.test(value)) {
    value = parseInt(value);
  }
  return new Date(value);
}

export function isMonthEqual(date1, date2) {
  date1 = date1 instanceof Date ? date1 : toDate(date1);
  date2 = date2 instanceof Date ? date2 : toDate(date2);

  return (
    date1.getMonth() === date2.getMonth() &&
    date1.getFullYear() === date2.getFullYear()
  );
}

export function getEndOfMonth(value) {
  const date = toDate(value);

  date.setMonth(date.getMonth() + 1);
  date.setDate(0);
  date.setHours(0, 0, 0, 0);
  return date;
}

export function getStartOfMonth(value) {
  const date = toDate(value);

  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

export function getNextMonth(value) {
  const date = toDate(value);

  date.setMonth(date.getMonth() + 1);
  return date;
}

export function getPrevMonth(value) {
  const date = toDate(value);

  date.setMonth(date.getMonth() - 1);
  return date;
}

export function toMonthLabel(date) {
  return `${MONTHS_NAME[date.getMonth()]} ${date.getFullYear()}`;
}
